var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgStepFour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 29.994,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 209 29.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#40f1e6",
    d: "M12.118-.12h5.519c7.677 2.019 11.836 7.018 12.478 14.997-.642 7.979-4.801 12.978-12.478 14.997h-5.519C5.559 28.274 1.48 24.195-.12 17.636v-5.519C1.48 5.558 5.559 1.479 12.118-.121Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#42f1e6",
    d: "M104.74-.12h5.999c0 .16.08.24.24.24.484.342 1.043.502 1.68.48 5.137 1.659 8.457 5.098 9.958 10.318a11.328 11.328 0 0 1 .36 2.879v2.16c-.861 7.486-4.94 12.125-12.238 13.917h-5.999c-7.298-1.792-11.377-6.431-12.238-13.917v-2.16c.861-7.486 4.94-12.125 12.238-13.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#41f1e6",
    d: "M190.644-.12h6.239c6.013 1.614 10.013 5.374 11.998 11.278v7.439c-1.985 5.904-5.984 9.664-11.998 11.278h-6.239c-6.009-1.569-9.968-5.329-11.878-11.278a14.62 14.62 0 0 1-.12-2.639v-2.16c.303-5.363 2.783-9.403 7.439-12.118a32.381 32.381 0 0 1 4.559-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8aeba4",
    d: "M110.979.12c.636-.022 1.196.138 1.68.48-.636.022-1.196-.138-1.68-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#353c46",
    d: "M19.556 10.918c1.002-.158 1.362.242 1.08 1.2l-6.599 6.598c-.32.16-.64.16-.96 0l-3.959-3.959c-.147-.861.213-1.141 1.08-.84l3.239 3.24a224.184 224.184 0 0 0 6.119-6.239Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#353d46",
    d: "M112.418 10.918c1.002-.158 1.362.242 1.08 1.2l-6.598 6.598c-.32.16-.64.16-.96 0a137.128 137.128 0 0 1-3.96-3.719 3.103 3.103 0 0 1-.12-1.2 3.12 3.12 0 0 1 1.2.12l3.24 3.24a224.387 224.387 0 0 0 6.119-6.239Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#353c45",
    d: "M198.562 10.918h.96a3.103 3.103 0 0 1-.12 1.2 93.008 93.008 0 0 1-7.079 6.719 35.382 35.382 0 0 1-4.439-4.079.6.6 0 0 1 0-.72c.414-.258.854-.298 1.32-.12a55.083 55.083 0 0 0 3.119 2.999l6.239-5.999Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.888
    },
    fill: "#b6c6d6",
    d: "M92.502 13.797v2.16H31.794v-2.16h60.708Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.889
    },
    fill: "#b6c6d7",
    d: "M122.976 13.797h55.669v2.16h-55.669v-2.16Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepFour);
export default __webpack_public_path__ + "static/media/StepFour.a81799a02c6e4941bcc12511c829d2ea.svg";
export { ForwardRef as ReactComponent };